(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["olive-product-tabs"] && !Shopify.designMode) return;
  try {
    
  class OliveProductTabs extends HTMLElement {
    connectedCallback() {
      if (this.isInitialized) return;

      this.isInitialized = true;
      this.panels = Array.from(this.querySelectorAll('.olive-product-tabs__panel'));
      this.carousels = this.panels.map((panel) => this.setupCarousel(panel)).filter(Boolean);
    }

    disconnectedCallback() {
      this.carousels?.forEach((carousel) => {
        carousel.track.removeEventListener('scroll', carousel.updateControls);
        carousel.previous.removeEventListener('click', carousel.showPrevious);
        carousel.next.removeEventListener('click', carousel.showNext);
        carousel.resizeObserver?.disconnect();
      });

      this.isInitialized = false;
    }

    setupCarousel(panel) {
      const track = panel.querySelector('[data-carousel-track]');
      const previous = panel.querySelector('[data-carousel-previous]');
      const next = panel.querySelector('[data-carousel-next]');
      if (!track || !previous || !next) return null;

      const getScrollAmount = () => {
        const firstItem = track.firstElementChild;
        if (!firstItem) return track.clientWidth;
        const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
        return firstItem.getBoundingClientRect().width + gap;
      };

      const updateControls = () => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maxScroll - 2;
        previous.hidden = maxScroll <= 2;
        next.hidden = maxScroll <= 2;
      };

      const showPrevious = () => track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      const showNext = () => track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });

      previous.addEventListener('click', showPrevious);
      next.addEventListener('click', showNext);
      track.addEventListener('scroll', updateControls, { passive: true });

      const resizeObserver = new ResizeObserver(updateControls);
      resizeObserver.observe(track);

      const carousel = { track, previous, next, updateControls, showPrevious, showNext, resizeObserver };
      panel._oliveCarousel = carousel;
      requestAnimationFrame(updateControls);
      return carousel;
    }
  }

  if (!customElements.get('olive-product-tabs')) {
    customElements.define('olive-product-tabs', OliveProductTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
